{
  "notifications": {
    "tripContainsTrain": {
      "text": "Tee <strong>lähtöselvitys junayhteydellesi</strong> erikseen Deutsche Bahnin sivustolla käyttäen <strong>Finnairin varaustunnusta</strong>.",
      "linkText": "Tee lähtöselvitys Deutsche Bahnin sivustolla"
    }
  }
}
